<template>
  <div class="horizon-container h-100">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 230px">
      <div class="bg-f3f4f7" style="height: 50px" @click="backTemplate">
        <button class="btn-30-border-30313a-small mt-10 text-left"><i class="el-icon-back mr-10"></i>选择工程进度模板</button>
      </div>
      <div class="plr-20 ptb-15 text-left">
        <div class="font-18-30313a font-bold">{{selectedTemplate.name}}</div>
        <div class="flex">
          <div class="btn-16-bg-82b925-r mt-5" v-if="selectedTemplate.status">发布</div>
          <div class="btn-16-bd-85-r mt-5" v-else>未发布</div>
        </div>
      </div>
      <div class="menu">
        <div v-for="(item, index) in menu" :key="index" :class="index === menuIndex ? 'menuActive': 'menuList'" @click="changeIndex(index,item.name)">
          <span class="cursor">{{item.name}}</span>
        </div>
      </div>
    </div>
    <move-horizon :min="50" :max="400"></move-horizon>
    <div class="flex-1 ml-5">
      <BudgetQuotation v-if="menuIndex === 0" :titleName="titleName" :selectedTemplate="selectedTemplate" :selectedTemplateId="selectedTemplateId" :define="1"></BudgetQuotation>
      <CostAccountingUnit v-if="menuIndex === 1" :titleName="titleName"></CostAccountingUnit>
    </div>
    <!--define 1 模板定义 2 房间定义-->
  </div>
</template>
<script>
import MoveHorizon from '../../../components/MoveHorizon'
import BudgetQuotation from '../../customer/budgetItem/budgetQuotation.vue'
import CostAccountingUnit from './costAccountingUnit'
export default {
  name: 'quotaTemplateDetail',
  components: {MoveHorizon, BudgetQuotation, CostAccountingUnit},
  props: ['selectedTemplate', 'selectedTemplateId'],
  data () {
    return {
      menuIndex: 0,
      titleName: '预算报价',
      menu: [{
        name: '预算报价'
      }, {
        name: '成本核算'
      }],
      budgetGroup: {
        id: '1234566'
      }
    }
  },
  created () {
  },
  mounted () {},
  methods: {
    backTemplate () {
      this.$parent.openDetailShow = false
    },
    changeIndex (a, b) {
      this.menuIndex = a
      this.titleName = b
    }
  }
}
</script>

<style lang="scss" scoped>
  .menuList{
    color: #30313a;
    font-size: 14px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: dashed 1px #e2e2e2;
    border-bottom: dashed 1px #e2e2e2;
  }
  .menuActive{
    color: #ffffff;
    font-size: 14px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5971d;
    border-bottom: dashed 1px #f5971d;
  }
  .btn-16-bg-82b925-r {
    line-height: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/component/quotaTemplateDetail.vue